import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissNumberField, CissTextField, StatusField } from 'components/fields';
import { Filter } from 'components/filter';
import { usePermissionsContext } from 'context/PermissionsContext';
import { FilterValuesProps } from 'hooks/useFilter';
import { getTypeMarketing, MarketingTradePage } from 'pages/marketing-trade/types';

export function MarketingTradeCampanhaListFilter({ isMarketing = false }: MarketingTradePage) {
    const { hasPermission } = usePermissionsContext();

    const [filterCodigo, setFilterCodigo] = useState<FilterValuesProps>({
        property: 'idCampanhaMarketing',
        operator: 'eq',
        value: '',
    });

    const [filterTitulo, setFilterTitulo] = useState<FilterValuesProps>({
        property: 'dsCampanhaMarketing',
        operator: 'like',
        value: '',
    });

    const [filterStatus, setFilterStatus] = useState<FilterValuesProps>({
        property: 'fgAtivo',
        operator: 'eq',
        value: hasPermission([isMarketing ? 'MARKETING_CAMPANHA_MODERAR' : 'TRADE_CAMPANHA_MODERAR']) ? null : true,
        idProperty: 'vlStatus',
    });

    const filterTipoMarketing: FilterValuesProps = {
        property: 'idTipoMarketing',
        operator: 'eq',
        value: getTypeMarketing(isMarketing),
    };

    return (
        <Filter
            filters={[
                { value: filterCodigo, setter: setFilterCodigo },
                { value: filterTitulo, setter: setFilterTitulo },
                { value: filterStatus, setter: setFilterStatus },
                { value: filterTipoMarketing },
            ]}
        >
            <Grid sx={{ flex: 1 }}>
                <CissNumberField
                    label="Código"
                    value={filterCodigo.value}
                    onChange={(e) => setFilterCodigo((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                    preventEmptyField={false}
                />
            </Grid>
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Título"
                    value={filterTitulo.value}
                    onChange={(e) => setFilterTitulo((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>

            {hasPermission([isMarketing ? 'MARKETING_CAMPANHA_MODERAR' : 'TRADE_CAMPANHA_MODERAR']) && (
                <Grid sx={{ flex: 1 }}>
                    <StatusField
                        value={filterStatus.value}
                        onChange={(e, value) => setFilterStatus((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                    />
                </Grid>
            )}
        </Filter>
    );
}
